import React from 'react';
import FontAwesomeIcon from 'src/components/Icon';
import { SelectedContact } from './CustomHooks/useContactPickerMultiOrchestrator';
import { CanonicalContact, ContactRole } from './helpers/contactShape';
import { GroupedContacts } from './helpers/groupByRole';
import ContactPickerPanel from './components/ContactPickerPanel';
import SelectedContactsList from './components/SelectedContactsList';
import './ContactPickerMultiple.scss';

interface ContactPickerMultipleProps {
  isLoading: boolean;
  selected: SelectedContact[];
  groupedResults: GroupedContacts[];
  availableCategories: string[];
  availableRoles: ContactRole[];
  searchTerm: string;
  selectedRoles: ContactRole[];
  selectedCategories: string[];
  subtitleVariant: 'role-only' | 'role-and-services';
  onChangeSearchTerm: (term: string) => void;
  onChangeSelectedRoles: (roles: ContactRole[]) => void;
  onChangeSelectedCategories: (categories: string[]) => void;
  onSelectContact: (contact: CanonicalContact) => void;
  onRemoveSelectedContact: (userId: string) => void;
}

export const ContactPickerMultiple = ({
  isLoading,
  selected,
  groupedResults,
  availableCategories,
  availableRoles,
  searchTerm,
  selectedRoles,
  selectedCategories,
  subtitleVariant,
  onChangeSearchTerm,
  onChangeSelectedRoles,
  onChangeSelectedCategories,
  onSelectContact,
  onRemoveSelectedContact,
}: ContactPickerMultipleProps) => {
  const visibleCount: number = groupedResults.reduce(
    (acc: number, group: GroupedContacts) => acc + group.contacts.length,
    0
  );

  return (
    <div className="contact-picker-multiple">
      <div className="contact-picker-multiple-column">
        <div className="contact-picker-column-header">
          <span className="contact-picker-column-title">Available contacts</span>
          <span className="contact-picker-column-count">{visibleCount}</span>
        </div>
        <ContactPickerPanel
          isLoading={isLoading}
          groupedResults={groupedResults}
          availableCategories={availableCategories}
          availableRoles={availableRoles}
          searchTerm={searchTerm}
          selectedRoles={selectedRoles}
          selectedCategories={selectedCategories}
          subtitleVariant={subtitleVariant}
          onChangeSearchTerm={onChangeSearchTerm}
          onChangeSelectedRoles={onChangeSelectedRoles}
          onChangeSelectedCategories={onChangeSelectedCategories}
          onSelectContact={onSelectContact}
        />
      </div>
      <div className="contact-picker-multiple-arrow" aria-hidden="true">
        <FontAwesomeIcon glyph="arrow-right" weight="light" />
      </div>
      <div className="contact-picker-multiple-column">
        <div className="contact-picker-column-header">
          <span className="contact-picker-column-title">Selected subscribers</span>
          <span className="contact-picker-column-count">{selected.length}</span>
        </div>
        <div className="contact-picker-multiple-right-panel">
          <SelectedContactsList
            selected={selected}
            onRemove={onRemoveSelectedContact}
          />
        </div>
      </div>
    </div>
  );
};

export default ContactPickerMultiple;